import { parsePhoneNumberFromString } from 'libphonenumber-js/min';

export default function formatPhoneNumber(phoneNumber) {
  if (!phoneNumber) {
    return phoneNumber;
  }

  const formatted = parsePhoneNumberFromString(phoneNumber, 'International');
  return formatted ? formatted.formatInternational() : phoneNumber;
}
